import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "labor-ratio-modal",
  "data-tour": "bb-test-labor-dialog"
}
const _hoisted_2 = { class: "lrm-header" }
const _hoisted_3 = { class: "lrm-header-icon" }
const _hoisted_4 = { class: "lrm-header-text" }
const _hoisted_5 = { class: "lrm-body" }
const _hoisted_6 = {
  key: 0,
  class: "lrm-state"
}
const _hoisted_7 = {
  key: 1,
  class: "lrm-state is-error"
}
const _hoisted_8 = { class: "lrm-summary-main" }
const _hoisted_9 = { class: "lrm-ratio-block" }
const _hoisted_10 = { class: "lrm-ratio-value" }
const _hoisted_11 = { class: "lrm-req-block" }
const _hoisted_12 = { class: "lrm-req-value" }
const _hoisted_13 = { class: "lrm-formula" }
const _hoisted_14 = { class: "lrm-calc-row" }
const _hoisted_15 = {
  key: 0,
  class: "lrm-need"
}
const _hoisted_16 = { class: "lrm-section" }
const _hoisted_17 = { class: "lrm-section-head" }
const _hoisted_18 = { class: "lrm-section-hint" }
const _hoisted_19 = { class: "lrm-table-wrap" }
const _hoisted_20 = { class: "lrm-table" }
const _hoisted_21 = { class: "num" }
const _hoisted_22 = { class: "num" }
const _hoisted_23 = { class: "num" }
const _hoisted_24 = { class: "num" }
const _hoisted_25 = {
  key: 1,
  class: "lrm-chip muted"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "lrm-section" }
const _hoisted_28 = { class: "lrm-section-head" }
const _hoisted_29 = { class: "lrm-section-total" }
const _hoisted_30 = { class: "lrm-note" }
const _hoisted_31 = { class: "lrm-table-wrap" }
const _hoisted_32 = { class: "lrm-table compact" }
const _hoisted_33 = { class: "num" }
const _hoisted_34 = { class: "num" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "lrm-section" }
const _hoisted_37 = { class: "lrm-section-head" }
const _hoisted_38 = { class: "lrm-section-total" }
const _hoisted_39 = { class: "lrm-note" }
const _hoisted_40 = {
  key: 0,
  class: "lrm-table-wrap"
}
const _hoisted_41 = { class: "lrm-table compact" }
const _hoisted_42 = { class: "num" }
const _hoisted_43 = { class: "num" }
const _hoisted_44 = { class: "num" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "lrm-table-wrap"
}
const _hoisted_47 = { class: "lrm-table compact" }
const _hoisted_48 = { class: "num" }
const _hoisted_49 = { class: "num" }
const _hoisted_50 = { key: 0 }

import { computed, ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'LaborRatioDetailModal',
  props: {
    modelValue: { type: Boolean },
    memberCode: {},
    year: {},
    month: {},
    bizGubun: {},
    bankCode: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const error = ref('');
const detail = ref<any>(null);

const cumulativeTo = computed(() =>
  Number(detail.value?.cumulativeTo || props.month) || Number(props.month) || 1
);

const cumulativeLabel = computed(() =>
  detail.value?.cumulativeLabel
  || (cumulativeTo.value <= 1 ? '1월 누적' : `1~${cumulativeTo.value}월 누적`)
);

const monthlyRows = computed(() => detail.value?.monthlyRows || []);

const formatWon = (n: number | null | undefined) => {
  const v = Number(n) || 0;
  return `${v.toLocaleString('ko-KR')}원`;
};

const load = async () => {
  if (!props.memberCode || !props.year || !props.month) return;
  loading.value = true;
  error.value = '';
  detail.value = null;
  try {
    const monthNum = parseInt(String(props.month), 10);
    const res = await bankbookApi.getAccountingAnalysisReference(
      String(props.memberCode),
      {
        year: String(props.year),
        month: String(monthNum),
        bizGubun: props.bizGubun || undefined,
        bankCode: props.bankCode || undefined,
        periodType: 'month',
        startMonth: monthNum,
        endMonth: monthNum,
      }
    );
    const data = res.data?.data;
    if (!data?.laborRatioDetail) {
      error.value = '인건비비율 상세 데이터가 없습니다.';
      return;
    }
    detail.value = data.laborRatioDetail;
  } catch (e: any) {
    console.error(e);
    error.value = e?.response?.data?.message || '인건비비율 내역을 불러오지 못했습니다.';
  } finally {
    loading.value = false;
  }
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) load();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "920",
    scrollable: "",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "22",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-percent-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", null, "인건비비율 계산 내역", -1)),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(__props.year) + "년 " + _toDisplayString(cumulativeLabel.value || '1월~해당월 누적') + " ", 1),
              (__props.bizGubun)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(__props.bizGubun), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "lrm-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "28",
                  width: "2",
                  color: "#1e3a5f"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "불러오는 중...", -1))
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(error.value), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "lrm-retry",
                    onClick: load
                  }, "다시 시도")
                ]))
              : (detail.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("section", {
                      class: _normalizeClass(["lrm-summary", detail.value.met ? 'is-ok' : (detail.value.income?.total > 0 ? 'is-warn' : 'is-empty')])
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "lrm-ratio-label" }, "실제 비율", -1)),
                          _createElementVNode("strong", _hoisted_10, _toDisplayString(detail.value.income?.total > 0 ? `${detail.value.ratio}%` : '-'), 1)
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "lrm-vs" }, "÷", -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "lrm-ratio-label" }, "기준", -1)),
                          _createElementVNode("strong", _hoisted_12, _toDisplayString(detail.value.requiredPercent) + "%", 1)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["lrm-verdict", detail.value.met ? 'ok' : 'warn'])
                        }, _toDisplayString(detail.value.income?.total > 0 ? (detail.value.met ? '충족' : '미충족') : '계산불가'), 3)
                      ]),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(detail.value.formula), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, "인건비지출 " + _toDisplayString(formatWon(detail.value.expense?.total)), 1),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "lrm-calc-sep" }, "÷", -1)),
                        _createElementVNode("span", null, "인건비수입 " + _toDisplayString(formatWon(detail.value.income?.total)), 1),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "lrm-calc-sep" }, "×", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "100", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "lrm-calc-eq" }, "=", -1)),
                        _createElementVNode("strong", null, _toDisplayString(detail.value.income?.total > 0 ? `${detail.value.ratio}%` : '-'), 1)
                      ]),
                      (detail.value.income?.total > 0 && !detail.value.met)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, " 기준 충족까지 약 " + _toDisplayString(formatWon(detail.value.needAmount)) + " 추가 지출 필요 ", 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("section", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = _createElementVNode("h4", null, "월별 · 누적 추이", -1)),
                        _createElementVNode("span", _hoisted_18, "1월부터 " + _toDisplayString(cumulativeTo.value) + "월까지", 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("table", _hoisted_20, [
                          _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "월"),
                              _createElementVNode("th", { class: "num" }, "당월 수입"),
                              _createElementVNode("th", { class: "num" }, "당월 지출"),
                              _createElementVNode("th", { class: "num" }, "누적 수입"),
                              _createElementVNode("th", { class: "num" }, "누적 지출"),
                              _createElementVNode("th", { class: "num" }, "누적 비율"),
                              _createElementVNode("th", null, "판정")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlyRows.value, (row) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.month,
                                class: _normalizeClass({ current: row.month === cumulativeTo.value })
                              }, [
                                _createElementVNode("td", null, _toDisplayString(row.label), 1),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(formatWon(row.income)), 1),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(formatWon(row.expense)), 1),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(formatWon(row.cumIncome)), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(formatWon(row.cumExpense)), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["num", row.cumRatio == null ? '' : (row.cumMet ? 'is-ok' : 'is-warn')])
                                }, _toDisplayString(row.cumRatio == null ? '-' : `${row.cumRatio}%`), 3),
                                _createElementVNode("td", null, [
                                  (row.cumRatio != null)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(["lrm-chip", row.cumMet ? 'ok' : 'warn'])
                                      }, _toDisplayString(row.cumMet ? '충족' : '미충족'), 3))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                                ])
                              ], 2))
                            }), 128)),
                            (!monthlyRows.value.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [...(_cache[14] || (_cache[14] = [
                                  _createElementVNode("td", {
                                    colspan: "7",
                                    class: "empty"
                                  }, "월별 데이터가 없습니다", -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[16] || (_cache[16] = _createElementVNode("h4", null, "인건비수입 구성", -1)),
                        _createElementVNode("strong", _hoisted_29, _toDisplayString(formatWon(detail.value.income?.total)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(detail.value.income?.publicNote || detail.value.income?.note), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("table", _hoisted_32, [
                          _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "계정"),
                              _createElementVNode("th", { class: "num" }, "건수"),
                              _createElementVNode("th", { class: "num" }, "금액")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((detail.value.income?.groups || []), (g) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: 'in-' + g.scode
                              }, [
                                _createElementVNode("td", null, _toDisplayString(g.sname || g.scode), 1),
                                _createElementVNode("td", _hoisted_33, _toDisplayString(g.count), 1),
                                _createElementVNode("td", _hoisted_34, _toDisplayString(formatWon(g.amount)), 1)
                              ]))
                            }), 128)),
                            (!(detail.value.income?.groups || []).length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [...(_cache[17] || (_cache[17] = [
                                  _createElementVNode("td", {
                                    colspan: "3",
                                    class: "empty"
                                  }, "해당 내역 없음", -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[19] || (_cache[19] = _createElementVNode("h4", null, "인건비지출 구성", -1)),
                        _createElementVNode("strong", _hoisted_38, _toDisplayString(formatWon(detail.value.expense?.total)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_39, _toDisplayString(detail.value.expense?.publicNote || detail.value.expense?.note), 1),
                      (detail.value.expense?.fromWage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("table", _hoisted_41, [
                              _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "연월"),
                                  _createElementVNode("th", { class: "num" }, "인건비"),
                                  _createElementVNode("th", { class: "num" }, "인건비가산"),
                                  _createElementVNode("th", { class: "num" }, "합계")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((detail.value.expense?.wageRows || []), (w, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: 'w-' + idx
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(w.label || w.yearMonth), 1),
                                    _createElementVNode("td", _hoisted_42, _toDisplayString(formatWon(w.laborCost)), 1),
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(formatWon(w.laborAdd)), 1),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(formatWon(w.amount)), 1)
                                  ]))
                                }), 128)),
                                (!(detail.value.expense?.wageRows || []).length)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [...(_cache[20] || (_cache[20] = [
                                      _createElementVNode("td", {
                                        colspan: "4",
                                        class: "empty"
                                      }, "임금 인건비 자료 없음", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("table", _hoisted_47, [
                              _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "계정"),
                                  _createElementVNode("th", { class: "num" }, "건수"),
                                  _createElementVNode("th", { class: "num" }, "금액")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((detail.value.expense?.bookGroups || []), (g) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: 'out-' + g.scode
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(g.sname || g.scode), 1),
                                    _createElementVNode("td", _hoisted_48, _toDisplayString(g.count), 1),
                                    _createElementVNode("td", _hoisted_49, _toDisplayString(formatWon(g.amount)), 1)
                                  ]))
                                }), 128)),
                                (!(detail.value.expense?.bookGroups || []).length)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [...(_cache[22] || (_cache[22] = [
                                      _createElementVNode("td", {
                                        colspan: "3",
                                        class: "empty"
                                      }, "해당 내역 없음", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})